import { $fetch } from '@/services/axios';

export function fetch(params) {
  return $fetch(`system/status`, params);
}
